export default __webpack_public_path__ + "static/media/dinero.6191230a.svg";